
import fetchInterceptor, { FetchOptions } from '../../../utils/fetchInterceptor ';
import {  getOccupancyEp as endpoint } from "../ApiEndPoints";
import { getReqPayload } from '../OccupancyTypes';
const GetOccupancyAPI = async ({ header }: getReqPayload) => {
    const url = endpoint()
    const options: FetchOptions = {
        method: "GET",
        headers: header,
    }
    return fetchInterceptor(url, options)

};

export default GetOccupancyAPI;